import { Maybe, TowingRecordPaymentType } from '../../common/types'
import { Item, ItemGroup } from '../../containers/Parameters/types'
import { EditArrivalRouteFormValues } from '../../containers/TowingRecordPage/components/routes/subforms/ArrivalRoute/types'
import { EditFinishRouteFormValues } from '../../containers/TowingRecordPage/components/routes/subforms/FinishRoute/types'
import { TowingRecord } from '../../containers/TowingRecordPage/ViewTowingRecord/types'
import { ArcCodeLists, INVALID_ARC_DESCRIPTION_CODE } from './types'

export const getBatteryServiceOptions = (itemGroups: Maybe<ItemGroup[]>, items: Maybe<Item[]>) => {
  const options = [{ value: 'other', label: 'Muu' }]

  if (!itemGroups || !items) {
    return options
  }

  const batteryGroup = itemGroups.find(group => group.name === 'AL-Akkupalvelu')

  if (batteryGroup) {
    items.forEach(item => {
      if (item.groups.includes(batteryGroup.id)) {
        options.unshift({ value: item.name, label: item.name })
      }
    })
  }

  return options
}

export const getDeliveredBattery = (towingRecord: TowingRecord) => {
  return towingRecord.automobileAndTouringClubFinland &&
    towingRecord.automobileAndTouringClubFinland.batteryService &&
    towingRecord.automobileAndTouringClubFinland.batteryService.deliveredBattery
    ? towingRecord.automobileAndTouringClubFinland.batteryService.deliveredBattery
    : null
}

export const getBatteryServiceBattery = (
  itemGroups: Maybe<ItemGroup[]>,
  items: Maybe<Item[]>,
  battery: Maybe<string>
) => {
  const options = getBatteryServiceOptions(itemGroups, items)

  const batteryFound = options.find(option => option.value === battery)

  if (batteryFound) {
    return batteryFound.value
  }

  return 'other'
}

export const paymentTypeOptions = [
  { value: 'invoice', label: 'Lasku' },
  {
    value: TowingRecordPaymentType.card,
    label: 'Korttimaksu',
  },
  { value: TowingRecordPaymentType.cash, label: 'Käteismaksu' },
]

export function getAlArcOptions(componentCode: string, descriptionCode: string, lists: Maybe<ArcCodeLists>) {
  if (!lists) return { arcComponentOptions: [], arcDescriptionOptions: [] }

  const { descriptions, components } = lists
  const selectedComponent = Array.isArray(components)
    ? components.find(component => Number(component.code) === Number(componentCode))
    : null

  if (!selectedComponent) {
    return { arcComponentOptions: [], arcDescriptionOptions: [] }
  }

  let filteredDescriptions = descriptions.filter(description =>
    selectedComponent.fault_codes.includes(Number(description.code))
  )

  if (Number(descriptionCode) === INVALID_ARC_DESCRIPTION_CODE) {
    filteredDescriptions = [...filteredDescriptions, { code: '46', type: '46 Ei diagnosoitavissa' }]
  }

  return {
    arcComponentOptions: components.map(component => {
      return {
        label: component.type,
        value: component.code,
      }
    }),
    arcDescriptionOptions: filteredDescriptions.map(description => {
      return {
        label: description.type,
        value: description.code,
      }
    }),
  }
}

export function validAlArcDescription(values: EditFinishRouteFormValues | EditArrivalRouteFormValues) {
  if(!values.automobileAndTouringClubFinland) return true;

  if(Number(values.automobileAndTouringClubFinland.arcCodes.description.code) === INVALID_ARC_DESCRIPTION_CODE) {
    return false
  }

  return true
}

export const getComponentType = (code: Maybe<string>, arcCodes: Maybe<ArcCodeLists>): string => {
  if(!arcCodes || !code) return ''
  const displayLabel = arcCodes.components.find(component => component.code === code)
  return displayLabel ? displayLabel.type : ''
}

export const getDescriptionType = (code: Maybe<string>, arcCodes: Maybe<ArcCodeLists>): string => {
  if(!arcCodes || !code) return ''
  const displayLabel = arcCodes.descriptions.find(description => description.code === code)
  return displayLabel ? displayLabel.type : ''
}